"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTextLabelIconBackground = exports.goldilocksButtonText = exports.calculateBodyColor = exports.getAccordionCollapsedButtonIcon = exports.getAccordionExpandedButtonIcon = exports.calculateFocusColor = exports.calculateButtonPosition = void 0;
var colord_1 = require("colord");
var mix_1 = __importDefault(require("colord/plugins/mix"));
var a11y_1 = __importDefault(require("colord/plugins/a11y"));
var ColorUtils_1 = require("@CommonFrontendBackend/StyleServiceV2/ColorUtils");
var BlockStyleTypes_1 = require("@CommonFrontendBackend/StyleServiceV2/BlockStyleTypes");
var pages_common_1 = require("@qwilr/pages-common");
(0, colord_1.extend)([a11y_1.default, mix_1.default]);
var calculateButtonPosition = function (style) {
    if (style.cardStyle === "visual") {
        return "right";
    }
    return style.buttonAlignment;
};
exports.calculateButtonPosition = calculateButtonPosition;
var calculateFocusColor = function (style) {
    var grey = (0, colord_1.colord)("#81A2B2");
    if (style.headerBackground.on) {
        var backgroundColor = style.headerBackground.color.abs;
        var colordBg = (0, colord_1.colord)(backgroundColor);
        if (colordBg.luminance() > 0.1) {
            var mixer_1 = grey.mix("#FFFFFF", 0.75).toHex();
            return (0, ColorUtils_1.multiply)(backgroundColor, mixer_1);
        }
        var mixer = grey.mix("#000000", 0.75).toHex();
        return (0, ColorUtils_1.screen)(backgroundColor, mixer);
    }
    return grey.alpha(0.75).toHex();
};
exports.calculateFocusColor = calculateFocusColor;
var getAccordionExpandedButtonIcon = function (style) {
    var url = style.buttonStyle === BlockStyleTypes_1.AccordionWidgetButtonStyle.Arrow
        ? "\"data:image/svg+xml;base64,".concat(Buffer.from("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path d=\"M8 7.685v8.63a1 1 0 001.479.878l7.912-4.315a1 1 0 000-1.756L9.479 6.807A1 1 0 008 7.685z\" fill=\"".concat(style.buttonColor.abs, "\"/></svg>")).toString("base64"), "\"")
        : "\"data:image/svg+xml;base64,".concat(Buffer.from("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"".concat(style.buttonColor.abs, "\" viewBox=\"0 0 24 24\"><path class=\"rectangle-h\" d=\"M19 11v2H5v-2z\" /></svg>")).toString("base64"), "\"");
    return "url(".concat(url, ") center no-repeat");
};
exports.getAccordionExpandedButtonIcon = getAccordionExpandedButtonIcon;
var getAccordionCollapsedButtonIcon = function (style) {
    var url = style.buttonStyle === BlockStyleTypes_1.AccordionWidgetButtonStyle.Arrow
        ? "\"data:image/svg+xml;base64,".concat(Buffer.from("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path d=\"M8 7.685v8.63a1 1 0 001.479.878l7.912-4.315a1 1 0 000-1.756L9.479 6.807A1 1 0 008 7.685z\" fill=\"".concat(style.buttonColor.abs, "\"/></svg>")).toString("base64"), "\"")
        : "\"data:image/svg+xml;base64,".concat(Buffer.from("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"".concat(style.buttonColor.abs, "\" viewBox=\"0 0 24 24\"><path class=\"rectangle-h\" d=\"M19 11v2H5v-2z\" /><path class=\"rectangle-v\" d=\"M13 19h-2V5h2z\" /></svg>")).toString("base64"), "\"");
    return "url(".concat(url, ") center no-repeat");
};
exports.getAccordionCollapsedButtonIcon = getAccordionCollapsedButtonIcon;
var calculateBodyColor = function (style) {
    var showCard = style.headerBackground.on || style.cardStyle === "visual";
    if (showCard && style.bodyBackground.on) {
        return (0, colord_1.colord)(style.headerBackground.color.abs).mix("#FFFFFF", 0.95).toHex();
    }
    if (showCard) {
        return "#FFFFFF";
    }
    return undefined;
};
exports.calculateBodyColor = calculateBodyColor;
var goldilocksButtonText = function (style) {
    return (0, pages_common_1.goldilocks)(style.buttonColor.abs, {
        mode: "text",
        foregroundColor: "white",
    });
};
exports.goldilocksButtonText = goldilocksButtonText;
var getTextLabelIconBackground = function (style) {
    var textColor = (0, exports.goldilocksButtonText)(style);
    var sanitisedColor = textColor.replace("#", "%23");
    return "url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20class%3D%22kl-icon%20kl-icon--medium%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20d%3D%22M12.293%206.293a1%201%200%20011.414%200l5%205a1%201%200%20010%201.414l-5%205a1%201%200%2001-1.414-1.414L15.586%2013H6a1%201%200%20110-2h9.586l-3.293-3.293a1%201%200%20010-1.414z%22%20fill%3D%22".concat(sanitisedColor, "%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E') center no-repeat");
};
exports.getTextLabelIconBackground = getTextLabelIconBackground;
